<template>
  <v-app>
    <h2>Page Not Found</h2>
  </v-app>
</template>

<script>
export default {
  name: "PageNotFound",
};
</script>

<style scoped>
</style>
